import {Box} from '@mui/material';
import {AppIconButton} from 'components/buttons';
import {AppConfirmationDialog, AppConfirmationDialogRefType} from 'components/dialogs';
import {useCreateTimeTrackerEntity, useStopTimeTrackerEntity, useTimeTrackerinRedux} from 'hooks';
import {TimeTrackerModel, TimeTrackerStatus} from 'models';
import {useEffect, useMemo, useRef, useState} from 'react';
import {FaPlay, FaStop} from 'react-icons/fa';
import {useSelector} from 'react-redux';
import {timeTrackerSelector} from 'store/timeTracker';
interface TimeTrackerStartAndStopButtonProps {
    itemDataId?: string;
    title: string;
    withoutStartButton?: boolean;
    withoutStopButton?: boolean;
    afterCreateUpdateHandler?: (item: TimeTrackerModel) => void;
}
export const TimeTrackerStartAndStopButton: React.FC<TimeTrackerStartAndStopButtonProps> = ({
    itemDataId,
    title,
    withoutStartButton = false,
    withoutStopButton = false,
    afterCreateUpdateHandler,
}) => {
    const [startNewTimer, setStartNewTimer] = useState(false);
    const {isConuterStarted, selectedTimeTrackInRedux, timeTrackerInterval} = useSelector(timeTrackerSelector);
    const {startConterInRedux, stopCounterInRedux, setTimeTrackerEntityInRedux} = useTimeTrackerinRedux();
    const {stopTimeTrackerEntity, stopTimeTrackerEntityLoading, stopTimeTrackerEntityResponse} =
        useStopTimeTrackerEntity();
    const {createTimeTrackerEntity, createTimeTrackerEntityLoading, createTimeTrackerEntityResponse} =
        useCreateTimeTrackerEntity();

    const isSelectITemData = useMemo((): boolean => {
        if (!itemDataId) {
            return true;
        }
        if (selectedTimeTrackInRedux) {
            return selectedTimeTrackInRedux.itemDataId === itemDataId;
        }
        return false;
    }, [itemDataId, selectedTimeTrackInRedux]);

    useEffect(() => {
        if (stopTimeTrackerEntityResponse && !stopTimeTrackerEntityLoading) {
            if (afterCreateUpdateHandler) {
                afterCreateUpdateHandler(stopTimeTrackerEntityResponse);
            }
            stopCounterInRedux();
            setTimeTrackerEntityInRedux(null);

            if (startNewTimer && itemDataId) {
                setStartNewTimer(false);
                createTimeTrackerEntity({
                    variables: {
                        input: {
                            itemDataId: itemDataId,
                            startTime: new Date().toISOString(),
                            title: title,
                            description: title,
                            status: TimeTrackerStatus.Running.toString(),
                            endTime: undefined,
                        },
                    },
                });
            }
        }
    }, [stopTimeTrackerEntityResponse, stopTimeTrackerEntityLoading, startNewTimer]);

    const confirmationDialiogRef = useRef<AppConfirmationDialogRefType>(null);
    const onCounterStopClickHandler = () => {
        if (selectedTimeTrackInRedux) {
            stopTimeTrackerEntity({variables: {id: selectedTimeTrackInRedux.id}});
        }
    };

    const onCounterStartHandler = () => {
        if (!isConuterStarted && itemDataId) {
            createTimeTrackerEntity({
                variables: {
                    input: {
                        itemDataId: itemDataId,
                        startTime: new Date().toISOString(),
                        title: title,
                        description: title,
                        status: TimeTrackerStatus.Running.toString(),
                        endTime: undefined,
                    },
                },
            });
        } else {
            if (confirmationDialiogRef.current) {
                confirmationDialiogRef.current.handleOpen();
            }
        }
    };
    useEffect(() => {
        if (!createTimeTrackerEntityLoading && createTimeTrackerEntityResponse) {
            setTimeTrackerEntityInRedux(createTimeTrackerEntityResponse);
            startConterInRedux();
        }
    }, [createTimeTrackerEntityLoading, createTimeTrackerEntityResponse]);

    const onConfimationHandler = () => {
        if (selectedTimeTrackInRedux) {
            stopCounterInRedux();
            setStartNewTimer(true);
            stopTimeTrackerEntity({
                variables: {
                    id: selectedTimeTrackInRedux.id,
                },
            });
        }
    };
    return (
        <>
            <Box>
                {!isSelectITemData && !withoutStartButton && (
                    <AppIconButton color="success" size="small" onClick={onCounterStartHandler}>
                        <FaPlay />
                    </AppIconButton>
                )}
                {isConuterStarted && isSelectITemData && !withoutStopButton && (
                    <Box display={'flex'} alignItems="center">
                        <AppIconButton
                            size="small"
                            color="error"
                            onClick={onCounterStopClickHandler}
                            isLoading={stopTimeTrackerEntityLoading}
                        >
                            <FaStop />
                        </AppIconButton>
                    </Box>
                )}
            </Box>
            <AppConfirmationDialog
                renderElement={() => <></>}
                ref={confirmationDialiogRef}
                onConfirmClick={(_open, _handleOpen, handleClose) => {
                    onConfimationHandler();
                    handleClose();
                }}
                title={'Are you sure you wan to stop the timer?'}
                description={'This will stop the timer and save the time entry and start a new one.'}
            />
        </>
    );
};

export default TimeTrackerStartAndStopButton;
